import { isAgentProfile } from "@/features/onboarding/agent-type";
import type { Viewer } from "@/server/auth/types";

export const identities = {
  creator: { label: "授权方", english: "CREATOR", title: "授权方控制台", color: "var(--color-cool)" },
  brand: { label: "电商 · 采购方", english: "E-COMMERCE", title: "电商控制台", color: "var(--color-warm)" },
  director: { label: "导演 · 影视方", english: "DIRECTOR", title: "导演控制台", color: "var(--color-accent)" },
  agent: { label: "区域代理", english: "AGENT", title: "区域代理控制台", color: "var(--color-verified)" },
  partner: { label: "厂商", english: "BUSINESS", title: "厂商控制台", color: "var(--color-accent)" },
} as const;
export type WorkbenchIdentity = keyof typeof identities;
export function resolveIdentity(role: Viewer["role"], profile?: { agentType?: string | null; agentCity?: string | null; merchantType?: string | null } | null): WorkbenchIdentity {
  if (role === "creator") return "creator";
  if (isAgentProfile(profile)) return "agent";
  if (profile?.merchantType === "director") return "director";
  if (profile?.merchantType === "brand") return "brand";
  return "partner";
}
